import Button from "@app/components/move2Library/Button/Button"
import { useCustomNavigation, useNavigationData } from "@app/components/navigation/NavigationHandler"
import { useRaiseError } from "@app/store/actions/errorActions"
import { useSavePlanningObject } from "@app/store/service/connectorService"
import { useState } from "react"
import { TabletSaunaBoatBase } from "../TabletSaunaBoatBase"

export default function TableSaunaBooking3() {
	const { option, names } = useNavigationData()
	const raiseError = useRaiseError()
	const [saveOption] = useSavePlanningObject()
	const { push } = useCustomNavigation()
	const [inProgress, setInProgress] = useState(false)

	return (
		<TabletSaunaBoatBase>
			<div className="f3 mb-5">Reservierungsdetails</div>
			<div>Gewählte Uhrzeit: {option.timeFrom.slice(0, 5)}</div>
			<div>Personenanzahl: {names.length}</div>

			<div className="mt-auto flex">
				<Button
					style="outlined"
					className="primary"
					onClick={() => {
						push("/tablet-sauna-boat-2", undefined, { option, names })
					}}
				>
					Zurück
				</Button>
				<Button
					style="secondary"
					className="ml-auto"
					disabled={inProgress}
					onClick={async () => {
						setInProgress(true)
						try {
							await saveOption({
								planningObject: {
									...option,
									date: new Date().toISOString().slice(0, 10),
									quantity: names.length,
									names,
								},
							}).unwrap()
							push("/tablet-sauna-boat-4")
						} catch (e) {
							raiseError(e)
						} finally {
							setInProgress(false)
						}
					}}
				>
					Speichern
				</Button>
			</div>
		</TabletSaunaBoatBase>
	)
}
